import withTranslations from 'support/hoc/withTranslations'
import { observer } from 'mobx-react'
import { SearchFilter as BaseSearchFilter } from '@morningtrain/react-filters'
import withDefaultProps from 'support/hoc/withDefaultProps'

function SearchFilter (props) {
  return <BaseSearchFilter {...props} />
}

SearchFilter.defaultProps = {
  name: 'search'
}

export default observer(
  withDefaultProps(
    withTranslations(SearchFilter),
    { name: 'search' }
  )
)
